module.exports = __webpack_public_path__ + "static/media/pickup_button.38d2741a.svg";